/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Permissions d'actions utilisateur
 * @export
 * @interface Permissions
 */
export interface Permissions {
    /**
     * Peut modifier les informations du risque
     * @type {boolean}
     * @memberof Permissions
     */
    canEditRisk: boolean;
    /**
     * Peut modifier les informations de l'assuré
     * @type {boolean}
     * @memberof Permissions
     */
    canEditInsured: boolean;
    /**
     * Peut modifier les conditions (SEPA/mandat)
     * @type {boolean}
     * @memberof Permissions
     */
    canEditConditions: boolean;
    /**
     * Peut envoyer le contrat pour signature
     * @type {boolean}
     * @memberof Permissions
     */
    canSendContract: boolean;
    /**
     * Peut signer le contrat
     * @type {boolean}
     * @memberof Permissions
     */
    canSignContract: boolean;
    /**
     * Peut signer le mandat SEPA
     * @type {boolean}
     * @memberof Permissions
     */
    canSignMandate: boolean;
}

/**
 * Check if a given object implements the Permissions interface.
 */
export function instanceOfPermissions(value: object): value is Permissions {
    if (!('canEditRisk' in value) || value['canEditRisk'] === undefined) return false;
    if (!('canEditInsured' in value) || value['canEditInsured'] === undefined) return false;
    if (!('canEditConditions' in value) || value['canEditConditions'] === undefined) return false;
    if (!('canSendContract' in value) || value['canSendContract'] === undefined) return false;
    if (!('canSignContract' in value) || value['canSignContract'] === undefined) return false;
    if (!('canSignMandate' in value) || value['canSignMandate'] === undefined) return false;
    return true;
}

export function PermissionsFromJSON(json: any): Permissions {
    return PermissionsFromJSONTyped(json, false);
}

export function PermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permissions {
    if (json == null) {
        return json;
    }
    return {
        
        'canEditRisk': json['canEditRisk'],
        'canEditInsured': json['canEditInsured'],
        'canEditConditions': json['canEditConditions'],
        'canSendContract': json['canSendContract'],
        'canSignContract': json['canSignContract'],
        'canSignMandate': json['canSignMandate'],
    };
}

export function PermissionsToJSON(json: any): Permissions {
    return PermissionsToJSONTyped(json, false);
}

export function PermissionsToJSONTyped(value?: Permissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canEditRisk': value['canEditRisk'],
        'canEditInsured': value['canEditInsured'],
        'canEditConditions': value['canEditConditions'],
        'canSendContract': value['canSendContract'],
        'canSignContract': value['canSignContract'],
        'canSignMandate': value['canSignMandate'],
    };
}

